<template>
  <div>

    <splitter-context-helper
      v-if="panel"
      :label="$t('dashboard:panel_settings.panel','Panel')"
      :value="panel.title"
    />

    <div v-if="panel" style="padding: 1rem;">
      <cc-form-input
        :label="$t('dashboard:panel_settings.form.title.label', 'Title')"
        :state="titleState.state"
        :invalid-feedback="titleState.message"
        :info-bubble-text="$t('dashboard:panel_settings.form.title.info_bubble', 'The title of the panel')"
      >
        <b-form-input
          v-model="panelTitle"
          :state="titleState.state"
          data-testid="txtPanelTitle"
          :disabled="formDisabled"
        />
      </cc-form-input>

      <cc-form-input
        :label="$t('dashboard:panel_settings.form.description.label', 'Description')"
        :info-bubble-text="$t('dashboard:panel_settings.form.description.info_bubble', 'Describe the panel (optional)')"
      >
        <b-form-textarea
          v-model="panelDescription"
          no-resize
          style="height: 200px;"
          :disabled="formDisabled"
        />
      </cc-form-input>
    </div>

    <div v-if="!panel" class="no-panel-selected">
      {{ $t("dashboard:panel_settings.no_panel_selected", 'Select a panel to edit. (Click the panel title and choose "settings")') }}
    </div>

  </div>
</template>

<style>

</style>

<script>
import SplitterContextHelper from '@/components/SplitterContextHelper';

export default {
  name: 'panel-settings',

  components: {
    SplitterContextHelper,
  },

  props: {
    saveTrigger: {
      type: Boolean,
    },
    panel: {
      type: Object,
    },
  },

  data() {
    return {
      formDisabled: true,
      panelTitle: '',
      panelDescription: '',
    };
  },

  computed: {
    titleState() {
      const value = { state: null, message: '' };

      if (!this.panelTitle) {
        value.state = false;
        value.message = this.$t('dashboard:panel_settings.form.title.error.required', "Title is required");
      }

      if (this.panelTitle.length > 50) {
        value.state = false;
        value.message = this.$t('dashboard:panel_settings.form.title.error.length', "Title cannot exceed 50 characters");
      }

      return value;
    },
  },

  methods: {
    init() {
      this.formDisabled = !this.$s.can.access('dashboard..entity.update');
      
      if (this.panel) {
        this.panelTitle = this.panel.title;
        this.panelDescription = this.panel.description || '';
      }
    },

    validate() {
      return this.titleState.state !== false;
    },

    emitValue() {
      const valid = this.validate();

      if (valid) {
        this.$emit('panel-updated', {
          title: this.panelTitle,
          description: this.panelDescription,
        });
      } else {
        this.$Toastr = {
          type: "error",
          message: this.$t("dashboard:panel_settings.toastr.invalid_form", "Please fix all form errors before saving."),
        };
      }
    },
  },

  watch: {
    saveTrigger(newValue, oldValue) {
      if (newValue === true) {
        this.emitValue();
        this.$emit('update:save-trigger', false);
      }
    },
    panel(newVal) {
      if (newVal !== null) {
        this.panelTitle = newVal.title;
        this.panelDescription = newVal.description || '';
      }
    },
  },

  mounted() {
    this.init();
  },
};
</script>